import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/map': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M560 32C558.1 32 556 32.4 554.1 33.2L384 96H384L212 35.3A64.3-64.3 0 0 1 191.8 32C185.1 32 178.4 33.1 171.9 35.1L20.1 87.9A32-32 0 0 1 0 117.7V464C0 473.2 7.5 480 16 480 17.9 480 20 479.6 21.9 478.8L192 416 364 476.7A64-64 0 0 1 404.1 476.9L555.9 424.1A32-32 0 0 1 576 394.3V48C576 38.8 568.5 32 560 32zM224 90.4L352 135.6V421.6L224 376.4V90.4zM48 418.1V129.1L176 84.5V370.7L175.4 371 48 418.1zM528 382.9L400 427.4V141.3L400.6 141 528 93.9V382.9z'
      }
    ]
  }
})
